<template>
  <v-container>
    <div style='padding-left: 20px; padding-right: 20px;'>
      <v-row>
        <v-col cols='6'>
          <p>Completed by: {{wo.asbuilt_completed_by}}</p>
        </v-col>
        <v-col cols='6'>
        </v-col>
        <v-col cols='3'>
          <p># of 1802s: {{wo.num_1802}}</p>
        </v-col>
        <v-col cols='3'>
          <p># of 1812s: {{wo.num_1812}}</p>
        </v-col>
        <v-col cols='2'></v-col>
        <v-col cols='4'>
          <p># of Shrubrisers: {{wo.num_shrubrisers}}</p>
        </v-col>
        <v-col cols='3'>
          <p># of 1804s: {{wo.num_1804}}</p>
        </v-col>
        <v-col cols='3'>
          <p># of 1804 SAMs: {{wo.num_1804_SAM}}</p>
        </v-col>
        <v-col cols='2'></v-col>
        <v-col cols='4'>
          <p># of Shrubblers: {{wo.num_shrubblers}}</p>
        </v-col>
        <v-col cols='3'>
          <p># of 3504s: {{wo.num_3504}}</p>
        </v-col>
        <v-col cols='3'>
          <p># of 3504 SAMs: {{wo.num_3504_SAM}}</p>
        </v-col>
        <v-col cols='2'></v-col>
        <v-col cols='4'>
          <p># Xeris: {{wo.num_xeris}}</p>
        </v-col>
        <v-col cols='3'>
          <p># of 5004s: {{wo.num_5004}}</p>
        </v-col>
        <v-col cols='3'>
          <p># of 5004 SAMs: {{wo.num_5004_SAM}}</p>
        </v-col>
        <v-col cols='2'></v-col>
        <v-col cols='4'>
          <p># Zones: {{wo.num_zones}}</p>
        </v-col>
        <v-col cols='3'>
          <p># of 5012s: {{wo.num_5012}}</p>
        </v-col>
        <v-col cols='9'></v-col>
        <v-col cols='3'>
          <p>1/4" tubing(feet): {{wo.quarter_tubing}}</p>
        </v-col>
        <v-col cols='4'>
          <p>3/4" poly(# of rolls): {{wo.three_quarter_poly}}</p>
        </v-col>
        <v-col cols='4'>
          <p>1" poly(# of rolls): {{wo.one_inch_poly}}</p>
        </v-col>
        <v-col cols='3'>
          <p>System supplied by a hosebib: {{wo.sys_supply_hosebib ? "Yes" : "No"}}</p>
        </v-col>
        <v-col cols='3'>
          <p>Charged line to a hosebib: {{wo.charged_line_to_hosebib ? "Yes" : "No"}}</p>
        </v-col>
        <v-col cols='6'></v-col>
        <v-col cols='3'>
          <p>Charged line to water feature: {{wo.charged_line_to_water ? "Yes" : "No"}}</p>
        </v-col>
        <v-col cols='3'>
          <p>Labeled rain sensor location: {{wo.labelled_rain_sensor_location ? "Yes" : "No"}}</p>
        </v-col>
        <v-col cols='6'></v-col>
        <v-col cols='6'>
          <p>Is there anything special to do at startup: {{wo.special_startup_required ? "Yes" : "No"}}</p>
        </v-col>
        <v-col cols='6'></v-col>
        <v-col cols='12' v-if='wo.special_startup_required'>
          <p>Special SU Instructions:</p>
          <p>{{wo.special_startup_description}}</p>
        </v-col>
        <v-col cols='6'>
          <p>Is there anything special to do at blowdown: {{wo.special_blowdown_required ? "Yes" : "No"}}</p>
        </v-col>
        <v-col cols='6'></v-col>
        <v-col cols='12' v-if='wo.special_blowdown_required'>
          <p>Special BD Instructions:</p>
          <p>{{wo.special_blowdown_description}}</p>
        </v-col>
        <v-col cols='12'>
          <p>Where is the controller located: {{wo.controller_location}}</p>
        </v-col>
        <v-col cols='6'>
          <p>Is this commercial: {{wo.is_commercial ? "Yes" : "No"}}</p>
        </v-col>
        <v-col cols='6'></v-col>
        <v-col cols='12' v-if='wo.is_commercial'>
          <p>Where is the shutoff located:</p>
          <p>{{wo.shutoff_location}}</p>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>

export default {
  name: 'wo-install-form',
  props: {
    wo: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    isSavingLine: false,
  }),
  mount(){
    console.log(this.wo);
  },
  methods: {
  },
}
</script>
